import Http from "../api/http";

export default class Common extends Http {
  constructor() {
    super();
  }

  /***********通用服务接口***************/
  /**
 * 数据字典
 * @param {Array} typeList -  typeList
 */
  common_dictionary() {
    return super.post("common/dictionary", ...arguments)
  }

  /**
  * 国家区号列表
  */
  common_getCountryCodeList() {
    return super.post("common/getCountryCodeList", ...arguments)
  }
}